import * as moment from 'moment';

export class DateRange {
  constructor(public start: moment.Moment, public end: moment.Moment) {}

  public clone(): DateRange {
    return new DateRange(this.start.clone(), this.end.clone());
  }

  public isSame(daterange: DateRange): boolean {
    if (daterange == null) {
      return false;
    }
    return this.start.isSame(daterange.start) && this.end.isSame(daterange.end);
  }

  public shiftRange(amount: number, unit: string): DateRange {
    const dateRange: DateRange = this.clone();
    switch (unit) {
      case 'months':
        dateRange.start.add(moment.duration(amount, 'months'));
        dateRange.end.add(moment.duration(amount, 'months'));
        break;
      default:
        dateRange.start.add(moment.duration(amount, 'days'));
        dateRange.end.add(moment.duration(amount, 'days'));
    }
    return dateRange;
  }

  public hash(): string {
    return this.start.format() + this.end.format();
  }
}
